import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines, productShortName } from '../data/offer';
export function ClosingSection() {
  return <section className="field-grid bg-forest-900 py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-54" data-mp="12t3stjme3hm5">
      <div className="mx-auto max-w-4xl px-4" data-id="element-55" data-mp="xthet7yqlxca">
        <div className="text-center" data-id="element-56" data-mp="xvv8bcdrr1hq">
          <h2 id="closing-title" className="text-balance text-3xl font-extrabold leading-tight text-cream sm:text-4xl" data-id="element-57" data-mp="1cqhwein7sbx1">
            El próximo lunes puedes seguir improvisando...
          </h2>
          <p className="mt-4 font-display text-2xl font-extrabold tracking-tight text-gold-400 sm:text-3xl" data-id="element-58" data-mp="1lj3c1pvju2hn">
            O puedes entrar al aula con todo listo desde hoy.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-59" data-mp="1vh9cs45md2kx">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-lg border-l-4 border-gold-500 bg-forest-950 px-4 py-3 text-sm font-semibold text-cream" data-id="element-60" data-mp="1qiy1rq3l8m14" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-61" data-mp="2gdomwzkdb0nf" />
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-62" data-mp="2q9jbebb9vpy4">
          <p className="leading-relaxed text-forest-100" data-id="element-63" data-mp="2q7yi0p0p2d1u">
            El {productShortName} no te convierte en mejor docente. Vos ya eres un buen docente.
          </p>
          <p className="mt-3 text-lg font-bold text-cream" data-id="element-64" data-mp="2zzl1t9r3lkg7">
            Lo que hace el megapack es darte el tiempo y las herramientas para que eso se note en cada clase.
          </p>
        </div>
      </div>
    </section>;
}